import * as tslib_1 from "tslib";
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of, forkJoin, zip } from 'rxjs';
import { switchMap, catchError, filter, mergeMap } from 'rxjs/operators';
import { GetConclusions, RiskAssessmentActionTypes, GetOcrConclusionSuccess, GetLatestOcrConclusionSuccess, GetFaceConclusionSuccess, GetLatestFaceConclusionSuccess, GetOcrResultsSuccess, UpdateVerificationConclusionFailure, GetOcrResultsFailure, GetConclusionsFailure, GetLatestOcrConclusionFailure, GetLatestFaceConclusionFailure, GetFaceResultsSuccess, GetFaceResultsFailure, GetReportsSuccess, GetReportsFailure, CreateApprovalStatusSuccess, CreateApprovalStatusFailure, CreateScreeningConclusionSuccess, CreateScreeningConclusionFailure, UpdateVerificationConclusionSuccess, GetApprovalStatus, GetApprovalStatusSuccess, GetApprovalStatusFailure, CreateRiskReportSuccess, CreateRiskReportFailure, } from 'store/actions/risk-assessment.actions';
import { UpdateCrpScreening, GetCustomer, GetCustomerStatus } from 'store/actions/customer.actions';
import { VerificationType } from 'modules/shared/models/record.models';
import { RiskAssessmentService } from 'modules/core/services/risk-assessment.service';
import { CustomerService } from 'modules/core/services/customer.service';
import { PusherService } from '../../services/pusher.service';
import { SnackbarService } from 'app/services/snackbar.service';
var RiskAssessmentEffects = /** @class */ (function () {
    function RiskAssessmentEffects(actions$, riskAssessmentService, customerService, snackBar, pusherService) {
        var _this = this;
        this.actions$ = actions$;
        this.riskAssessmentService = riskAssessmentService;
        this.customerService = customerService;
        this.snackBar = snackBar;
        this.pusherService = pusherService;
        this.GetReports = this.actions$.pipe(ofType(RiskAssessmentActionTypes.GET_REPORTS), filter(function (input) { return input.payload.customerId; }), mergeMap(function (res) {
            return _this.riskAssessmentService.getRiskReports((res.payload)).pipe(switchMap(function (i) {
                return [new GetReportsSuccess(i), new GetApprovalStatus({
                        customerId: res.payload.customerId,
                        limit: 5
                    })];
            }), catchError(function (err) {
                _this.snackBar.error('Error: Failed to retrieve risk reports');
                return of(new GetReportsFailure(err));
            }));
        }));
        this.GetOcrResults = this.actions$.pipe(ofType(RiskAssessmentActionTypes.GET_OCR_RESULTS), mergeMap(function (input) {
            return _this.riskAssessmentService.getOcrResults((input.payload)).pipe(switchMap(function (res) {
                return of(new GetOcrResultsSuccess(res));
            }), catchError(function (err) { return of(new GetOcrResultsFailure(err)); }));
        }));
        this.CreateRiskReport = this.actions$.pipe(ofType(RiskAssessmentActionTypes.CREATE_RISK_REPORT), mergeMap(function (input) {
            return _this.customerService.createRiskReports(input.payload.customerId).pipe(switchMap(function (riskReport) {
                return zip(of(riskReport), _this.customerService.getCustomer(input.payload.customerId), of(input.payload.redirectToScreening));
            }), switchMap(function (_a) {
                var riskReport = _a[0], customer = _a[1], redirect = _a[2];
                if (riskReport) {
                    // if (riskReport.latestApprovalStatus && riskReport.latestApprovalStatus.approvalStatus === ApprovalStatusChoices.ACCEPTED) {
                    //   this.snackBar.success(`Risk Assessment done. customer ${customer.name} has been automatically cleared by the system`);
                    // } else {
                    //   this.snackBar.success(`Risk Assessment done for customer ${customer.name}.
                    //    Please submit screening conclusion(s) for all related parties to view risk report`);
                    // }
                    // temporarily not able to tell whether the customer is auto cleared, need BE changes
                    _this.snackBar.success("Risk Assessment done for customer " + customer.name + ".\n              Please submit screening conclusion(s) for all related parties if the customer is not auto cleared.");
                }
                return [new CreateRiskReportSuccess(riskReport), new GetCustomerStatus({
                        customerId: input.payload.customerId
                    })];
            }), catchError(function (err) {
                _this.snackBar.error('Error: Failed to generate risk report');
                return of(new CreateRiskReportFailure(err));
            }));
        }));
        this.GetFaceResults = this.actions$.pipe(ofType(RiskAssessmentActionTypes.GET_FACE_RESULTS), mergeMap(function (input) {
            return _this.riskAssessmentService.getFaceResults((input.payload)).pipe(switchMap(function (res) {
                return of(new GetFaceResultsSuccess(res));
            }), catchError(function (err) { return of(new GetFaceResultsFailure(err)); }));
        }));
        this.GetConclusions = this.actions$.pipe(ofType(RiskAssessmentActionTypes.GET_CONCLUSIONS), mergeMap(function (input) {
            return _this.riskAssessmentService
                .getVerificationConclusions(input.payload)
                .pipe(switchMap(function (conclusion) {
                return of([input.payload.verificationType, conclusion]);
            }), switchMap(function (res) {
                var type = res[0];
                var conclusion = res[1];
                if (type === VerificationType.OCR) {
                    return of(new GetOcrConclusionSuccess(conclusion));
                }
                else {
                    return of(new GetFaceConclusionSuccess(conclusion));
                }
            }), catchError(function (err) { return of(new GetConclusionsFailure(err)); }));
        }));
        this.GetLatestOcrConclusions = this.actions$.pipe(ofType(RiskAssessmentActionTypes.GET_LATEST_OCR_CONCLUSIONS), mergeMap(function (input) {
            var crps = input.payload ? input.payload : [];
            var obs = [];
            crps.forEach(function (crp) {
                obs.push(_this.riskAssessmentService.getVerificationConclusions({
                    crpId: crp.id,
                    limit: 1,
                    verificationType: VerificationType.OCR
                }));
            });
            return forkJoin(obs).pipe(switchMap(function (res) {
                var conclusions = res ? res : [];
                var latestConclusions = {};
                conclusions.forEach(function (conclusion) {
                    if (conclusion.results[0]) {
                        latestConclusions[conclusion.results[0].crp] = conclusion.results[0];
                    }
                });
                return of(new GetLatestOcrConclusionSuccess(latestConclusions));
            }), catchError(function (err) { return of(new GetLatestOcrConclusionFailure(err)); }));
        }));
        this.GetLatestFaceConclusions = this.actions$.pipe(ofType(RiskAssessmentActionTypes.GET_LATEST_FACE_CONCLUSIONS), mergeMap(function (input) {
            var crps = input.payload ? input.payload : [];
            var obs = [];
            crps.forEach(function (crp) {
                obs.push(_this.riskAssessmentService.getVerificationConclusions({
                    crpId: crp.id,
                    limit: 1,
                    verificationType: VerificationType.FACE
                }));
            });
            return forkJoin(obs).pipe(switchMap(function (res) {
                var conclusions = res ? res : [];
                var latestConclusions = {};
                conclusions.forEach(function (conclusion) {
                    if (conclusion.results[0]) {
                        latestConclusions[conclusion.results[0].crp] = conclusion.results[0];
                    }
                });
                return of(new GetLatestFaceConclusionSuccess(latestConclusions));
            }), catchError(function (err) { return of(new GetLatestFaceConclusionFailure(err)); }));
        }));
        this.CreateScreeningConclusion = this.actions$.pipe(ofType(RiskAssessmentActionTypes.CREATE_SCREENING_CONCLUSION), filter(function (input) { return input.payload.customer; }), mergeMap(function (input) {
            return _this.riskAssessmentService
                .createScreeningConclusion(input.payload)
                .pipe(switchMap(function (conclution) {
                return [
                    new CreateScreeningConclusionSuccess(conclution),
                    new UpdateCrpScreening(conclution),
                ];
            }), catchError(function (err) {
                _this.snackBar.error('Error: Failed to update screening conclusion');
                return of(new CreateScreeningConclusionFailure(err));
            }));
        }));
        this.UpdateVerificationConclusion = this.actions$.pipe(ofType(RiskAssessmentActionTypes.UPDATE_VERIFICATION_CONCLUSIONS), switchMap(function (input) {
            return _this.riskAssessmentService
                .updateVerificationConclusions((input.payload)).pipe(switchMap(function (conclution) { return [
                new GetConclusions({
                    crpId: input.payload.crpId,
                    limit: input.payload.limit,
                    offset: input.payload.offset,
                    sort: input.payload.sort,
                    verificationType: input.payload.verificationType
                }),
                new UpdateVerificationConclusionSuccess(conclution),
            ]; }), catchError(function (err) {
                _this.snackBar.error('Error: Failed to update verification conclusion');
                return of(new UpdateVerificationConclusionFailure(err));
            }));
        }));
        this.GetApprovalStatus = this.actions$.pipe(ofType(RiskAssessmentActionTypes.GET_APPROVAL_STATUS), filter(function (input) { return input.payload.customerId; }), mergeMap(function (input) {
            return _this.riskAssessmentService.getApprovalStatuses(input.payload).pipe(switchMap(function (res) {
                return of(new GetApprovalStatusSuccess(res));
            }), catchError(function (err) { return of(new GetApprovalStatusFailure(err)); }));
        }));
        this.CreateApprovalStatus = this.actions$.pipe(ofType(RiskAssessmentActionTypes.CREATE_APPROVAL_STATUS), filter(function (input) { return input.payload.customerId; }), switchMap(function (input) {
            return _this.riskAssessmentService.createApprovalStatus(input.payload).pipe(switchMap(function (status) {
                _this.snackBar.success('Approval status successfully updated');
                return [
                    new CreateApprovalStatusSuccess(status),
                    new GetApprovalStatus({
                        customerId: input.payload.customerId,
                        limit: 5
                    }),
                    new GetCustomer({ customerId: input.payload.customerId }),
                ];
            }), catchError(function (err) {
                if (err.status === 403) {
                    _this.snackBar.error(err.error.detail);
                }
                else {
                    _this.snackBar.error('Error: Failed to update approval status');
                }
                return of(new CreateApprovalStatusFailure(err));
            }));
        }));
        this.CreateRiskReportSuccess$ = this.actions$.pipe(ofType(RiskAssessmentActionTypes.CREATE_RISK_REPORT_SUCCESS), switchMap(function (riskReportResponse) {
            _this.pusherService.requestReloadScreening({
                customerId: riskReportResponse.payload.customer
            });
            return of({});
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RiskAssessmentEffects.prototype, "GetReports", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RiskAssessmentEffects.prototype, "GetOcrResults", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RiskAssessmentEffects.prototype, "CreateRiskReport", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RiskAssessmentEffects.prototype, "GetFaceResults", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RiskAssessmentEffects.prototype, "GetConclusions", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RiskAssessmentEffects.prototype, "GetLatestOcrConclusions", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RiskAssessmentEffects.prototype, "GetLatestFaceConclusions", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RiskAssessmentEffects.prototype, "CreateScreeningConclusion", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RiskAssessmentEffects.prototype, "UpdateVerificationConclusion", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RiskAssessmentEffects.prototype, "GetApprovalStatus", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], RiskAssessmentEffects.prototype, "CreateApprovalStatus", void 0);
    tslib_1.__decorate([
        Effect({ dispatch: false }),
        tslib_1.__metadata("design:type", Observable)
    ], RiskAssessmentEffects.prototype, "CreateRiskReportSuccess$", void 0);
    return RiskAssessmentEffects;
}());
export { RiskAssessmentEffects };
